import React from 'react';
import { Grid } from '@material-ui/core';
import { JobModel } from '../NewsfeedModels';
import PayIcon from 'assets/icons/pay_icon.svg';
import ChildrenIcon from 'assets/icons/children_icon.svg';
import PetIcon from '@material-ui/icons/Pets';
import JobCardDates from './JobCardDates';
import JobCardDetailRow from './JobCardDetailRow';
import { Colors } from 'library';
import { JobTypeIds } from '../../../../models/JobType';

const JobCardDetails = ({ job }: { job: JobModel }) => {
    const getDependentsText = () =>
        job.job_type_id === JobTypeIds.PetCare
            ? `${job.kids.length} Pet${job.kids.length === 1 ? '' : 's'}`
            : `${job.kids.length} Child${job.kids.length === 1 ? '' : 'ren'}`;

    const getPayText = () => {
        let pay = job.pay ? `$${job.pay}` : `$${job.rate_min} - $${job.rate_max}`;
        let units = job.pay_is_fixed ? ' total' : '/hr';
        return `${pay}${units}`;
    };

    const getDependentsIcon = () => {
        if (job.job_type_id === JobTypeIds.PetCare) {
            return <PetIcon htmlColor={Colors.darkNavy} fontSize="small" />;
        }
        return <ChildrenIcon color={Colors.darkNavy} />;
    };

    return (
        <Grid style={styles.area}>
            <JobCardDetailRow icon={getDependentsIcon()} text={getDependentsText()} visible={job.kids?.length > 0} />
            <JobCardDates job={job} />
            <JobCardDetailRow icon={<PayIcon color={Colors.darkNavy} />} text={getPayText()} visible />
        </Grid>
    );
};

export default JobCardDetails;

const styles = {
    area: {
        paddingBottom: 8,
        alignItems: 'flex-start',
    },
};
